import { LicenseManager } from "ag-grid-enterprise";
import "ag-grid-enterprise";
if (process.env.VUE_APP_AG_GRID_KEY)
	LicenseManager.setLicenseKey(process.env.VUE_APP_AG_GRID_KEY);
